import { useState, useEffect, RefObject } from "react";

export function useScrollToTopCheck(
  ref: RefObject<HTMLDivElement>,
  deps: any[] = []
): boolean {
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);

  useEffect(() => {
    if (!ref.current) return;
    let isTicking = false;
    const refCurrent = ref.current;

    const handleScroll = () => {
      if (!isTicking) {
        isTicking = true;

        requestAnimationFrame(() => {
          const newState = ref.current!.scrollTop < 10;
          if (newState !== isScrolledToTop) {
            setIsScrolledToTop(newState);
          }
          isTicking = false;
        });
      }
    };

    ref.current.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      refCurrent?.removeEventListener("scroll", handleScroll);
    };
  }, [ref, isScrolledToTop, deps]);

  return isScrolledToTop;
}
